import { Grid, IconButton, InputAdornment, debounce } from '@mui/material';
import OutlinedInput from 'components/inputs/outlined-input';

import { IActivityFeedSearch } from './types';

import { styles } from './styles';

import SearchIcon from 'assets/icons/buttons/activity-feed-search.svg';
import CrossIcon from 'assets/icons/buttons/close-search-icon.svg';
import { useCallback, useState } from 'react';

export const ActivityFeedSearch = ({
  searchQuery,
  showSearch,
  onSearchClose,
  onSearchOpen,
  onSetSearchQuery,
  showTabs = false,
}: IActivityFeedSearch) => {
  const [search, setSearch] = useState(searchQuery);

  const onSearchChange = debounce(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSearch(event.target.value);
      onSetSearchQuery(event.target.value);
    },
    300
  );

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSearch(event.target.value);
      onSearchChange(event);
    },
    []
  );

  if (showTabs && !showSearch) {
    return (
      <IconButton onClick={onSearchOpen} disableRipple={true} sx={styles.searchIcon}>
        <SearchIcon />
      </IconButton>
    );
  }

  return (
    <Grid>
      <OutlinedInput
        fullWidth
        withoutHelperText
        placeholder="Search"
        startAdornment={
          <InputAdornment position="start" sx={styles.inputAdornment}>
            <Grid item sx={{ marginRight: '10px' }}>
              <SearchIcon />
            </Grid>
          </InputAdornment>
        }
        endAdornment={
          <IconButton
            disableRipple={true}
            sx={styles.searchButton}
            onClick={() => {
              onSetSearchQuery('');
              setSearch('');
              showTabs && onSearchClose(); // Fire event only if we are showing tabs
            }}
          >
            <CrossIcon />
          </IconButton>
        }
        onChange={onChange}
        sx={styles.headerInput}
        value={search}
      />
    </Grid>
  );
};
